import React from 'react';
import { Label, Input, Row, Col, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faHistory, faBell } from '@fortawesome/free-solid-svg-icons';
import { numStr, t } from '../common/Translate';
import { usePricingTab } from '../../hooks/usePricing/usePricingTab';
import HistoryModal from './History';
import PricingBloc from './PricingBloc';
import { versionsListPresenter } from '../../Utils/presenters/vincheck/versionsPresenter';
import LicensePlateAlertModal from './LicensePlateAlertModal';
import { Auth } from '../../config/configuration/react';

export const PricingTab = () => {
  const {
    versions,
    mileage,
    onChange,
    refresh,
    recordId,
    readOnly,
    linkVinPage,
    showHistory,
    historys,
    toggle,
    modal,
    dateFormat,
    disabled,
    isLoading,
    standardMileage,
    vinPage,
    role,
    concessionIds,
    usedImmatRecords,
    LicensePlateAlertNumber,
    alertModal,
    toggleAlert,
    cancelAlert,
    Name,
    recordCountryId,
    CounterAppraisalAnalys,
    getVehicleVersionsByDecodeVin,
    vinVersions,
    vinVersionsLoading,
    checkedVinVersions,
    versionType,
    changeVersion,
    currentVersion,
    versionSupplier,
    versionOrg,
    buyerVersionList,
    carEquipment,
  } = usePricingTab();
  const showBtnVinPage = false;
  const showImmats = LicensePlateAlertNumber > 0;
  const enableVinDecodingForUser = Auth.isAllowedToVinDecoding();
  return (
    <>
      <Row className="mt-2">
        <Col className="">
          <Row>
            <Col xs={12} sm={12} md={4} lg={4}>
              <Label for="versionId" className="text-secondary text-uppercase font-weight-light text-left">
                {t('version_name')}
              </Label>
              <Input
                type="select"
                className="rounded"
                id="versionId"
                onChange={(e) => onChange(e)}
                disabled={readOnly}
                value={
                  versionsListPresenter(changeVersion.current && vinVersions ? vinVersions : versions).filter(
                    (version) => version.selected === true,
                  )?.[0]?.id
                }
              >
                {(versions || vinVersions) &&
                  versionsListPresenter(changeVersion.current && vinVersions ? vinVersions : versions).map((version) =>
                    version.id === -1 ? (
                      <option disabled>----------------------------------------------</option>
                    ) : (
                      <React.Fragment key={version.id}>
                        <option value={version.id}>{version.name}</option>
                      </React.Fragment>
                    ),
                  )}
              </Input>
              {enableVinDecodingForUser && buyerVersionList && (
                <small className="info-text-2 text-left mt-n2 mb-3">
                  Version selected by the buyer : {` ${buyerVersionList}`}
                </small>
              )}
              {CounterAppraisalAnalys && (
                <div className="p-2 d-flex">
                  <FontAwesomeIcon icon={faBell} size="x" color="red" />
                  <span>&nbsp;&nbsp;</span>
                  <span className="text-danger"> warningAppraisalData </span>
                  <span>&nbsp;&nbsp;</span>
                </div>
              )}
            </Col>
            <Col xs={6} sm={6} md={3} lg={2}>
              <Label for="mileage" className="text-secondary text-uppercase font-weight-light text-left">
                {t(recordCountryId === 16 ? 'mileageInMiles' : 'observed_mileage')}
              </Label>
              <Input
                type="text"
                className="form-control rounded"
                id="mileage"
                onChange={(e) => onChange(e)}
                value={mileage}
                disabled={readOnly}
              />
              {standardMileage && (
                <small className="info-text-2 text-left mt-n2 mb-3">
                  {t(recordCountryId === 16 ? 'milesStandard' : 'kmStandard')} {numStr(standardMileage)}
                </small>
              )}
            </Col>
            {!readOnly && (
              <Col xs={6} sm={6} md={3} lg={2}>
                <Label>&nbsp;</Label>
                <button
                  type="button"
                  className="btn btn-block btn-1 mb-1 custom-padding"
                  onClick={refresh}
                  disabled={disabled}
                >
                  <span className="d-inline-block d-sm-none d-lg-inline-block ml-2">
                    {isLoading && <Spinner size="sm" />}
                    {t('analysePricing')}
                  </span>
                </button>
              </Col>
            )}
            {enableVinDecodingForUser && [4].includes(Auth.roleId()) && !carEquipment?.length && (
              <Col xs={6} sm={6} md={3} lg={2}>
                <Label>&nbsp;</Label>
                <button
                  type="button"
                  className="btn btn-primary btn-block custom-padding"
                  onClick={getVehicleVersionsByDecodeVin}
                  disabled={vinVersionsLoading || (versionType && versionType === 'vin')}
                >
                  {t('decodeVin')}
                  {vinVersionsLoading && <Spinner className="ml-3" style={{ height: '0.1rem', width: '0.1rem' }} />}
                </button>
              </Col>
            )}
            {vinPage && (
              <Col xs={12} sm={2} md={2} lg={2} className="mb-2">
                <Label className="d-none d-sm-block">&nbsp;</Label>
                <a
                  href={linkVinPage}
                  className="btn btn-2 btn-block px-2 custom-padding"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="d-inline-block d-sm-none d-lg-inline-block ml-2">{t('VIN_page')}</span>
                </a>
              </Col>
            )}
            {showBtnVinPage && (
              <Col xs={12} sm={2} md={2} lg={2} className="mb-2">
                <Label className="d-none d-sm-block">&nbsp;</Label>
                <a
                  href={`/files/${recordId}/vincheck`}
                  className="btn btn-outline-primary btn-block px-2 custom-padding"
                >
                  <FontAwesomeIcon icon={faLink} />
                  <span className="d-inline-block d-sm-none d-lg-inline-block ml-2">{t('VIN_page')}</span>
                </a>
              </Col>
            )}

            {showHistory && (
              <Col xs={12} sm={2} md={2} lg={2}>
                <Label className="d-none d-sm-block">&nbsp;</Label>
                <button type="button" className="btn btn-block btn-3 custom-padding" onClick={toggle}>
                  <FontAwesomeIcon icon={faHistory} />
                  <span className="d-inline-block d-sm-none d-lg-inline-block ml-2">{t('pricingHistory')}</span>
                </button>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
      <HistoryModal historys={historys} toggle={toggle} modal={modal} dateFormat={dateFormat} />
      {showImmats && (
        <LicensePlateAlertModal
          LicensePlateAlertNumber={LicensePlateAlertNumber}
          usedImmatRecords={usedImmatRecords}
          role={role}
          concessionIds={concessionIds}
          alertModal={alertModal}
          toggleAlert={toggleAlert}
          cancelAlert={cancelAlert}
          fileName={Name}
        />
      )}
      <PricingBloc
        readOnly={readOnly}
        vinVersions={vinVersions}
        versionType={versionType}
        checkedVinVersions={checkedVinVersions}
        versions={versions}
        currentVersion={currentVersion}
        enableVinDecodingForUser={enableVinDecodingForUser}
        versionSupplier={versionSupplier}
        versionOrg={versionOrg}
        carEquipment={carEquipment}
      />
    </>
  );
};
